import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

export const MySwal = withReactContent(Swal);

const useSweetAlert = () => {
    return MySwal;
};

export default useSweetAlert;